import { render } from "./distributefun.vue?vue&type=template&id=8b53fa64&scoped=true"
import script from "./distributefun.vue?vue&type=script&lang=js"
export * from "./distributefun.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b53fa64"]])

export default __exports__